module.exports = __webpack_public_path__ + "static/media/vf-button-shoes-black.214b3a4e.svg";